import React from 'react';
import { NODE_TYPES } from './FlowNode';
import { Plus } from 'lucide-react';

const NodePalette = ({ onAddNode }) => {
    const nodeCategories = [
        {
            label: 'Start & End',
            types: ['start', 'success', 'failure'],
        },
        {
            label: 'Communication',
            types: ['message', 'question'],
        },
        {
            label: 'Logic',
            types: ['condition', 'delay'],
        },
        {
            label: 'Actions',
            types: ['action', 'order'],
        },
    ];

    const getColorClasses = (color) => {
        const colors = {
            emerald: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/30 hover:border-emerald-500/60',
            sky: 'bg-sky-500/10 text-sky-500 border-sky-500/30 hover:border-sky-500/60',
            violet: 'bg-violet-500/10 text-violet-500 border-violet-500/30 hover:border-violet-500/60',
            amber: 'bg-amber-500/10 text-amber-500 border-amber-500/30 hover:border-amber-500/60',
            orange: 'bg-orange-500/10 text-orange-500 border-orange-500/30 hover:border-orange-500/60',
            slate: 'bg-slate-500/10 text-slate-400 border-slate-500/30 hover:border-slate-500/60',
            pink: 'bg-pink-500/10 text-pink-500 border-pink-500/30 hover:border-pink-500/60',
            red: 'bg-red-500/10 text-red-500 border-red-500/30 hover:border-red-500/60',
        };
        return colors[color] || colors.sky;
    };

    return (
        <div className="w-64 bg-[#0d1424] border-r border-white/10 flex flex-col h-full">
            <div className="p-4 border-b border-white/10">
                <h3 className="font-semibold text-white">Add Steps</h3>
                <p className="text-xs text-white/50 mt-1">
                    Click to add to canvas
                </p>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-6">
                {nodeCategories.map(category => (
                    <div key={category.label}>
                        <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-3">
                            {category.label}
                        </h4>
                        <div className="space-y-2">
                            {category.types.map(type => {
                                const nodeType = NODE_TYPES[type];
                                if (!nodeType) return null;

                                const Icon = nodeType.icon;
                                const colorClasses = getColorClasses(nodeType.color);

                                return (
                                    <button
                                        key={type}
                                        onClick={() => onAddNode?.(type)}
                                        className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-all hover:scale-[1.02] active:scale-[0.98] ${colorClasses}`}
                                    >
                                        <div className="p-2 rounded-lg bg-white/10">
                                            <Icon size={16} />
                                        </div>
                                        <div className="flex-1 text-left">
                                            <p className="text-sm font-medium text-white">
                                                {nodeType.label}
                                            </p>
                                            <p className="text-xs text-white/40 line-clamp-1">
                                                {nodeType.description}
                                            </p>
                                        </div>
                                        <Plus size={14} className="text-white/30" />
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            {/* Tips */}
            <div className="p-4 border-t border-white/10 bg-white/[0.02]">
                <h4 className="text-xs font-semibold text-white/40 uppercase tracking-wider mb-2">
                    Tips
                </h4>
                <ul className="text-xs text-white/50 space-y-1">
                    <li>• Drag nodes to reposition</li>
                    <li>• Click output handles to connect</li>
                    <li>• Use conditions to branch flow</li>
                </ul>
            </div>
        </div>
    );
};

export default NodePalette;
